import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import App from './App';
import "./index.css";
import './config/axiosClient';
import { GlobalStyles, theme } from '@bpba/ui-components';
import 'leaflet/dist/leaflet.css';
 
ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles/>
         <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);